import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonCieModel } from 'src/app/model/common/cie';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConsultDiagnosticService extends BaseService {
  constructor(override store: Store<any>, protected rest: RestService) {
    super();
  }

  fillCieSuggestion = (query: string): Observable<CommonCieModel[]> =>
    this.rest.get<CommonCieModel[]>({
      url: `${environment.endpoints.common}/cie`,
      params: { query },
    });
}
